export default function handleNavClick(e,target=null) {
    e.preventDefault();
    let link = e.target;
    target = (target?target:link.href.substr(link.href.indexOf("#")+1));

    document
        .getElementById(target)
        .scrollIntoView({ behavior: 'smooth' });
}